export default {
	data() {
		return {
			
		}
	},
	computed: {
		isFileUploadRequest() {
			return !!this.$route.query?.uploadRequestId;
		}
	},
	mounted() {
		
	},
	destroyed() {
		
	},
	methods: {
		
	}
};
